/**
 * React Query Client
 *
 * Centralized QueryClient configuration with cache strategies
 * tuned for an ERP dashboard.
 */

import { QueryClient } from '@tanstack/react-query';

export const CACHE_TIMES = {
  DEFAULT: 5 * 60 * 1000,       // 5 minutes
  STATIC: 30 * 60 * 1000,       // 30 minutes (categories, brands, roles)
  USER: 10 * 60 * 1000,         // 10 minutes (user profile, permissions)
  DASHBOARD: 2 * 60 * 1000,     // 2 minutes (stats, counts)
  REALTIME: 30 * 1000,          // 30 seconds (active orders)
};

export const STALE_TIMES = {
  DEFAULT: 60 * 1000,           // 1 minute
  STATIC: 10 * 60 * 1000,      // 10 minutes
  DASHBOARD: 30 * 1000,         // 30 seconds
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: STALE_TIMES.DEFAULT,
      gcTime: CACHE_TIMES.DEFAULT,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
